import SSSlide from './00-slideshare_slide';

function SSInfographicSlide(config) {
  SSSlide.call(this, config);
  this.padding = 5;

  // Infographic hover title only on slideview
  if (this.config.hosted_in === 'slideview') {
    this.bindScrollEvents();
  }
}

SSInfographicSlide.prototype = new SSSlide();

SSInfographicSlide.prototype.empty = function () {};

SSInfographicSlide.prototype.setContainer = function (config) {
  var mode = config.mode;
  if (this.viewModes[mode] === undefined) {
    this.viewModes[mode] = {
      rendered: false,
      bgColor: config.bgColor || 'jsplBgColorBigfoot',
      container: config.container,
      wrapper: $('<div/>'),
    };
  }

  this.viewModes[mode].container.css({
    position: 'relative',
  });

  this.currentViewMode = this.viewModes[mode];
  this.currentViewMode.wrapper.removeClass('hide');
  this.currentMode = config.mode;
};

SSInfographicSlide.prototype.show = function (force) {
  if (this.currentViewMode.rendered && !force) {
    return;
  }
  this.currentViewMode.rendered = true;
  this.load();
};

SSInfographicSlide.prototype.hide = function () {
  this.$slide.hide();
};

SSInfographicSlide.prototype.displayLoading = function () {};

SSInfographicSlide.prototype.bindScrollEvents = function () {
  var that = this;
  var $parentEl = $('#slideview-container');

  $(document).ready(function () {
    // Height of navbar
    var navbar_height = parseInt($('#main-nav').height(), 10) || 51;

    // Positioning of share elements within player
    var share_cta_rel_top = 8;
    var share_modal_rel_top = 0;

    // Min distance between top of button/modal and bottom of player
    var bottom_padding = 550;

    // Threshold height of player for stickiness to apply
    var min_player_height = 550;

    var $player = $('#svPlayerId');
    var playerHeight = parseInt($player.css('height'), 10);

    // If the player is not tall enough (i.e., not an infographic), don't make
    // the modal share and share button and title sticky
    if (playerHeight < min_player_height) {
      $parentEl.removeClass('infographicHoverTitle');
      return;
    }

    // Update the position every 10 ms
    var update_position = true;
    setInterval(function () {
      update_position = true;
    }, 10);

    // Make the modal share and share button "sticky", i.e. scroll the modal
    // share and the share button along with the page.
    // Also, toggle the title's stickiness depending on position on the page
    if (that.config.playerType === 'infographic') {
      $(window).on('scroll', function (e) {
        if (update_position && $player && $player.offset()) {
          // Only run the code at intervals (see setInterval above)
          update_position = false;

          // Absolute position of the top of the player.  Not cached because it
          // can change as divs are added to/removed from page
          var abs_top = $player.offset().top;

          var scroll_top = $(this).scrollTop();
          var max_top = playerHeight + abs_top - bottom_padding;

          if (scroll_top > max_top) {
            // Do not continue adjusting the top value once user gets to bottom
            scroll_top = max_top;
          }

          var controller = $.slideshareEventManager.getController();
          var isFullScreen =
            controller.currentViewMode === 'nativefullscreen' ||
            controller.currentViewMode === 'fullscreen';

          if (scroll_top > abs_top && !isFullScreen) {
            // Scroll the share button and share modal down the requisite amount
            // Don't set the top property in full screen.
            $('.action-btns-container').css(
              'top',
              share_cta_rel_top + scroll_top - abs_top + 'px'
            );
            $('.modal-popup').css(
              'top',
              share_modal_rel_top + scroll_top - abs_top + 'px'
            );

            // Toggle infographic title sticky hover on/off on scrolling past the
            // title's anchor position when not in fullscreen
            var visibleBelowPlayer =
              $(this).scrollTop() +
              $(this).height() -
              $player.height() -
              $player.offset().top;
            $parentEl.toggleClass(
              'infographicHoverTitle',
              visibleBelowPlayer <= 0
            );
          } else {
            // Return share button and share modal to their default positions
            // Adding 12px to position Share CTA correctly with respect to
            // 'exit_full_screen icon
            $('.action-btns-container').css(
              'top',
              share_cta_rel_top + 12 + 'px'
            );
            $('.modal-popup').css('top', share_modal_rel_top + 'px');
          }
        }
      });
    }
  });
};

export default SSInfographicSlide;